import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Select, Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, MenuItem, IconButton, ListItemText} from '@material-ui/core';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { getObjectByID } from '../../../api/helpers';


class ServerGroupMapList_ extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            //licenses: this.props.licenses,
            menuAnchor: null, 
            menuItem: '',
            selected: ''
        }

        this.handleLocalNetworkSelect = this.handleLocalNetworkSelect.bind(this)
        this.handleRemoteNetworkSelect = this.handleRemoteNetworkSelect.bind(this)

        this.handleLocalGroupSelect = this.handleLocalGroupSelect.bind(this)
        this.handleRemoteGroupSelect = this.handleRemoteGroupSelect.bind(this)

    }

    getRowStyle(id){
        //let selected = id === this.state.selected
        //console.log('ServerGroupMapList_.getRowStyle '+id + ' =? '+ this.state.selected)
        let selected = id === this.state.selected
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleItemSelect(id){
        this.setState({selected: id})
        //this.props.onAction({type: 'SELECT_CURRENT_SERVER', externalServerID: id})
    }

    handleDeleteItem(index){
        this.props.onAction({
            type: 'GROUP_MAP_DELETE', 
            externalServerID: this.props.currentServer.ServerLink.ID, 
            index: index
        })
        //alert('delete '+index)
    }

    getGroups(networkID, networks){

        //console.log('getGroups '+networkID)
        //console.log(networks)

        let network = getObjectByID(networkID, networks)

        if(network) return network.Groups

        return []
    }

    handleLocalNetworkSelect(event, mapIndex){
        //console.log('handleLocalNetworkSelect')
        //console.log(event)

        this.props.onAction({type:'SET_LOCAL_NETWORK_ID', index: mapIndex, value: event.target.value} )
    }

    handleRemoteNetworkSelect(event, mapIndex){
        //console.log('handleRemoteNetworkSelect')
        //console.log(event)
        
        this.props.onAction({type:'SET_EXTERNAL_NETWORK_ID', index: mapIndex, value: event.target.value} )
    }

    handleLocalGroupSelect(event, mapIndex){
        //console.log('handleLocalGroupSelect')
        //console.log(event)

        this.props.onAction({type:'SET_LOCAL_GROUP_ID', index: mapIndex, value: event.target.value} )

    }

    handleRemoteGroupSelect(event, mapIndex){
        //console.log('handleRemoteGroupSelect')
        //console.log(event)

        this.props.onAction({type:'SET_EXTERNAL_GROUP_ID', index: mapIndex, value: event.target.value} )
    }

    handleMenuItemClick(menu){

        if(menu==='GROUP_MAP_ADD'){

            this.props.onAction({type:'GROUP_MAP_ADD'} )

        }

    }


    render(){
        const {t} = this.props

        //console.log('render Server Links List')
        //console.log(this.props)

        //this.state.licenses.sort(sortByName)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        return(
            <>
                <Paper style={styles.paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={1} style={styles.head}>{t('LocalNetwork')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('LocalGroup')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('ExternalNetwork')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('ExternalGroup')}</TableCell>

                                <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="more" component="span"
                                        style={styles.addIcon}
                                        disabled={!this.props.currentServer}
                                        onClick={()=>{this.handleMenuItemClick('GROUP_MAP_ADD')}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {this.props.currentServer ? this.props.currentServer.GroupMap.map((groupMap, index) => 
                            <TableRow key={index+' '+groupMap.LocalGroupId+'_'+groupMap.ExternalGroupId} 
                                    onClick={()=>{this.handleItemSelect(index)}}
                                    style={this.getRowStyle(index)}>

                                <TableCell component="th" scope="row">
                                    <SelectNetwork 
                                        name='LocalNetworkId'
                                        mapIndex={index}
                                        networkID={groupMap.LocalNetworkId}
                                        currentServer={this.props.currentServer}
                                        networks={this.props.currentServer.LocalServerObjects.Networks}
                                        onSelect={this.handleLocalNetworkSelect}  
                                    />
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    <SelectGroup 
                                        name='LocalGroupId'
                                        mapIndex={index}
                                        networkID={groupMap.LocalNetworkId}
                                        currentServer={this.props.currentServer}
                                        groupID={groupMap.LocalGroupId}
                                        groups={this.getGroups(groupMap.LocalNetworkId, this.props.currentServer.LocalServerObjects.Networks)}
                                        onSelect={this.handleLocalGroupSelect}
                                    />
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    <SelectNetwork 
                                        name='ExternalNetworkId'
                                        mapIndex={index}
                                        networkID={groupMap.ExternalNetworkId}
                                        currentServer={this.props.currentServer}
                                        networks={this.props.currentServer.RemoteServerObjects.Networks} 
                                        onSelect={this.handleRemoteNetworkSelect}
                                    />
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    <SelectGroup 
                                        name='ExternalGroupId'
                                        mapIndex={index}
                                        networkID={groupMap.ExternalNetworkId}
                                        groupID={groupMap.ExternalGroupId}
                                        groups={this.getGroups(groupMap.ExternalNetworkId, this.props.currentServer.RemoteServerObjects.Networks)}
                                        currentServer={this.props.currentServer}
                                        onSelect={this.handleRemoteGroupSelect}
                                    />
                                </TableCell>

                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="more" component="span"
                                        disabled={!this.props.currentServer}
                                        onClick={event=>this.handleDeleteItem(index)}>
                                        <DeleteForeverIcon/>
                                    </IconButton>
                                </TableCell>
                                
                            </TableRow>
                        ):null}
                        </TableBody>

                    </Table>    
                </Paper>
            </>
        )

    }

}

class SelectNetwork extends React.Component{

    checkError(){

        if(!this.props.networkID){
            return(true)
        }

        if(this.props.networkID){
            let exists = false
            this.props.networks.forEach(net => {
                if(net.ID===this.props.networkID){
                    exists = true
                }
            })

            if(!exists) return true

        }

        return false
    }


    render(){

        //console.log('render SelectNetwork '+ this.props.mapIndex)
        //console.log(this.props.networks)
        //console.log(this.props.currentServer)

        let error = this.checkError()
        //console.log(error)

        return(
            <Select 
                style={{minWidth: 180}}
                error={error}
                value={this.props.networkID?this.props.networkID:''}
                onChange={event=>{
                    this.props.onSelect(event, this.props.mapIndex)
                }}
                inputProps={{
                    name: this.props.name,
                    id: this.props.name,
                }}
                >

                {this.props.networks.map(net => (
                    <MenuItem key={net.ID} value={net.ID}>{net.Name}</MenuItem>
                ))}
            </Select>
        )

    }

}

class SelectGroup extends React.Component{


    checkError(){

        if(!this.props.groupID){
            return(true)
        }

        if(this.props.groupID){
            let exists = false
            this.props.groups.forEach(group => {
                if(group.ID===this.props.groupID){
                    exists = true
                }
            })

            if(!exists) return true

        }

        return false
    }



    render(){

        //console.log('render SelectGroup '+ this.props.mapIndex)
        //console.log(this.props.groups)
        //console.log(this.props.currentServer)

        let error = this.checkError()
        ///console.log(error)

        return(
            <Select 
                style={{minWidth: 180}}
                error={error}
                value={this.props.groupID?this.props.groupID:''}
                onChange={event=>{
                    this.props.onSelect(event, this.props.mapIndex)
                }}
                inputProps={{
                    name: this.props.name,
                    id: this.props.name,
                }}
                >

                {this.props.groups.map(group => (
                    <MenuItem key={this.props.networkID+'_'+group.ID} value={group.ID}>{group.Name}</MenuItem>
                ))}
            </Select>
        )

    }

}

export const ServerGroupMapList = withTranslation()(ServerGroupMapList_);